import lrTenantCompanyId from './_src/lrTenantCompanyId.vue'
lrTenantCompanyId.install = function(Vue) {
  Vue.component(lrTenantCompanyId.name, lrTenantCompanyId)
}

export default lrTenantCompanyId